import React, { Component } from 'react';
import './styles.css';
import Item from './Item';
import ItemLabel from './ItemLabel';
class AppleSelectorLayout extends Component {
	render() {
		return <div className="apple-selector-layout">{this.props.children}</div>;
	}
}

Object.assign(AppleSelectorLayout, {
	Item,
	ItemLabel
});

export default AppleSelectorLayout;
